import type {IconBaseProps, IconType} from "react-icons";
import {BsBrowserChrome, BsBrowserEdge, BsBrowserSafari} from "react-icons/bs";
import {CgBrowser} from "react-icons/cg";
import {FaFirefoxBrowser} from "react-icons/fa6";

export const BrowserIcon: IconType = (props: IconBaseProps) => {
  let IconComponent = CgBrowser;
  if (navigator.userAgent.includes("Chrome")) {
    IconComponent = BsBrowserChrome;
  } else if (navigator.userAgent.includes("Firefox")) {
    IconComponent = FaFirefoxBrowser;
  } else if (navigator.userAgent.includes("Safari")) {
    IconComponent = BsBrowserSafari;
  } else if (navigator.userAgent.includes("Edge")) {
    IconComponent = BsBrowserEdge;
  }
  return <IconComponent {...props} />;
};
